import { createStore } from 'vuex';
import settings from './modules/settings';
import user from './modules/user';
import balance from './modules/balance';
import leverage from './modules/leverage';
import lt from './modules/lt';
import exchange from './modules/exchange';
import loan from './modules/loan';
import theme from './modules/theme';
import bot from './modules/bot';

export default createStore({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        balance,
        settings,
        user,
        leverage,
        lt,
        exchange,
        loan,
        theme,
        bot,
    },
});
